import styles from '@components/Slider/Slider.styles';
import Icon from '@components/icons/Icon';
import { TIcon } from '@components/icons/typescript';
import { firstUppercase } from '@utils/misc';
import Button from '@components/Button/Button';
type PropsType = {
  direction: 'right' | 'left';
  callback: () => void;
  hidden?: boolean;
};
const SliderArrowControl = ({
  direction,
  callback,
  hidden = false
}: PropsType) => {
  const iconName = `BigChevron${firstUppercase(direction)}` as TIcon;
  return <Button variant="iconOnly" variantColor="white" onClick={callback} addSx={styles.sliderArrowControl(direction, hidden)}>
      <Icon icon={iconName} size={['60px', '100px']} />
    </Button>;
};
export default SliderArrowControl;